import type { CustomField } from '../types';

export type ItemTypeCustomFieldVisibilityRow = { field_def_id?: string; visible?: boolean };

/**
 * An item type shows a custom field when its visibility list marks it `visible: true`. A type with no list
 * shows every field, as the legacy pages did.
 */
export const isCustomFieldVisibleForItemTypeVisibility = (
	field: Pick<CustomField, 'id'>,
	itemTypeCustomFieldVisibility: ItemTypeCustomFieldVisibilityRow[] | null | undefined
): boolean => {
	if (itemTypeCustomFieldVisibility == null) return true;

	return itemTypeCustomFieldVisibility.some(
		(row) => String(row.field_def_id) === String(field.id) && row.visible === true
	);
};
